import QRCode from "../../../../content/articles/2014-11-14-creating-qr-codes-in-rails/qrcode.png";
import React from 'react';
export default {
  QRCode,
  React
};